// extracted by mini-css-extract-plugin
export var columnsComponent = "index-module--columnsComponent--27701";
export var columnsComponentColumn = "index-module--columnsComponentColumn--60442";
export var columnsComponentColumnHeader = "index-module--columnsComponentColumnHeader--fd994";
export var columnsComponentColumnIndex = "index-module--columnsComponentColumnIndex--a122f";
export var columnsComponentColumns = "index-module--columnsComponentColumns--fea00";
export var columnsComponentDescription = "index-module--columnsComponentDescription--d6870";
export var columnsComponentHeader = "index-module--columnsComponentHeader--92f4c";
export var columnsComponentHeading = "index-module--columnsComponentHeading--a30b2";
export var hasTextWeightLight = "index-module--has-text-weight-light--52e11";